import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Aos from 'aos';
import 'aos/dist/aos.css';

const Card = ({ project }) => {

  const [showMore, setShowMore] = useState({});
  
  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);


  const toggleShowMore = (id) => {
    setShowMore((prevState) => ({ ...prevState, [id]: !prevState[id] }));
  };

  
  return (
    <div className="card bg-[#515151] text-white font-inria p-4 rounded-xl shadow-md" data-aos='fade-left'>
      <img src={project.imageUrl} alt={project.title} className="w-full h-48 object-cover rounded-xl" />
      <div className="p-4">
        <h2 className="text-lg font-semibold">{project.title}</h2>
        {/* <p className="text-sm mt-2 text-black">{project.description}</p> */}
        <p className="text-sm mt-2 text-black">{showMore[project._id] ? project.description : `${project.description.substring(0, 100)}...`}
                    <button
                      onClick={() => toggleShowMore(project._id)}
                      className="text-[#E4B379] ml-2"
                    >
                      {showMore[project._id] ? 'Show less' : 'Show more'}
                    </button>
                    </p>
        <div className='flex justify-between'>
        <Link to={project.githubLink} target='/blank'>
          <button className="mt-4 px-8 py-1 border-[#E4B379] border bg-[#515151] shadow-md shadow-[#E4B379] text-white rounded-full hover:bg-[#E4B379] hover:text-black hover:shadow-transparent transition-colors">
            Source Code
          </button>
        </Link>
        {project.deployment && (
            <Link to={project.deployment} target='_blank' className='mt-6' title='Hosted Link'>
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 256 256">
                <path fill="white" d="M204 64v104a12 12 0 0 1-24 0V93L72.49 200.49a12 12 0 0 1-17-17L163 76H88a12 12 0 0 1 0-24h104a12 12 0 0 1 12 12"/>
              </svg>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

const CardGrid = ({ displayCount, gridTemplate }) => {

  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await fetch('https://sirichandhanak-backend.vercel.app/api/projects');
        if (!response.ok) {
          throw new Error('Failed to fetch Projects');
        }
        const data = await response.json();
        console.log(data);
        const reversedData = data.reverse(); 
        setProjects(reversedData);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching Projects:', error);
      }
    };

    fetchProjects();

    const loadingTimeout = setTimeout(() => {
      setLoading(false);
    }, 2000); 

    return () => clearTimeout(loadingTimeout);
  }, []);


  const getPlaceholderCount = () => {
    if (gridTemplate.includes('md:grid-cols-2')) return 2;
    if (gridTemplate.includes('md:grid-cols-3')) return 3;
    return 1; // Default to 1 if gridTemplate doesn't match specific conditions
  };

  if (loading) {
    return (
      <div className={`grid gap-6 p-4 ${gridTemplate}`}>
        {Array(getPlaceholderCount()).fill(0).map((_, index) => (
          <div key={index} className="bg-[#515151] p-6 rounded-lg animate-pulse">
            <div className="h-48 bg-gray-500 rounded mb-4"></div>
            <div className="h-4 bg-gray-500 rounded mb-4"></div>
            <div className="h-16 bg-gray-500 rounded mb-4"></div>
            <div className="h-8 bg-gray-500 rounded"></div>
          </div>
        ))}
      </div>
    );
  }
  
  return (
    <div className={`grid gap-6 p-4 ${gridTemplate}`}>
      {projects.slice(0, displayCount).map((project, index) => (
        <Card 
        key={index}
        project={project}
        />
      ))}
    </div>
  );
};

export default CardGrid;
